/**
 * OVERRIDE RenderBlocks.jsx
 * REASON: This customization supports Block Model v3, along with the previous implementation.
 * DATE: 2024-02-08
 * DEVELOPER: @sneridagh
 */

import RenderBlocks from '../../../../../components/Theme/RenderBlocks';

export default RenderBlocks;
